import { render, staticRenderFns } from "./download_app.vue?vue&type=template&id=119673d1&scoped=true"
import script from "./download_app.vue?vue&type=script&lang=js"
export * from "./download_app.vue?vue&type=script&lang=js"
import style0 from "./download_app.vue?vue&type=style&index=0&id=119673d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119673d1",
  null
  
)

export default component.exports